import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const CalendarIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-calendar', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.33335 1.49335C5.70154 1.49335 6.00002 1.79182 6.00002 2.16001V2.82001H10V2.16001C10 1.79182 10.2985 1.49335 10.6667 1.49335C11.0349 1.49335 11.3334 1.79182 11.3334 2.16001V2.82001H12.6667C13.0349 2.82001 13.3334 3.11849 13.3334 3.48668V13.3333C13.3334 13.7015 13.0349 14 12.6667 14H3.33335C2.96516 14 2.66669 13.7015 2.66669 13.3333V3.48668C2.66669 3.11849 2.96516 2.82001 3.33335 2.82001H4.66669V2.16001C4.66669 1.79182 4.96516 1.49335 5.33335 1.49335ZM4.00002 5.33335V12.6667H12V5.33335H4.00002Z'
      />
    </svg>
  );
};

export default CalendarIcon;
